module.exports = __webpack_public_path__ + "media/images/help/about/heading-reason-1-80118d8e9139b1dfeca652a4fc17f210.svg";